import { IconWrapper } from '../runtime';
export default IconWrapper('poster-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '9b380804' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.9995 4.55829C13.6888 4.02021 13.0008 3.83585 12.4627 4.14651L5.31798 8.27151C4.7799 8.58218 4.59554 9.27021 4.9062 9.80829L6.5937 12.7311L4.64514 13.8561C4.28643 14.0632 4.16352 14.5219 4.37063 14.8806L4.74563 15.5302C4.95273 15.8889 5.41143 16.0118 5.77014 15.8047L18.7605 8.30469C19.1192 8.09758 19.2422 7.63889 19.035 7.28017L18.66 6.63065C18.4529 6.27193 17.9942 6.14902 17.6355 6.35613L15.687 7.48113L13.9995 4.55829ZM8.54192 11.6055L8.60496 11.5692L8.61118 11.5656L8.61553 11.5631C9.80932 10.874 12.1353 9.53136 13.7382 8.60569L12.6134 6.65757L7.41726 9.65757L8.54192 11.6055ZM14.9999 13.8749C14.9999 14.4962 14.4962 14.9999 13.8749 14.9999C13.2536 14.9999 12.7499 14.4962 12.7499 13.8749C12.7499 13.2536 13.2536 12.7499 13.8749 12.7499C14.4962 12.7499 14.9999 13.2536 14.9999 13.8749ZM7.20553 16.8741C7.18054 16.8331 7.15649 16.7916 7.13335 16.7496L9.08323 15.6238C9.09074 15.639 9.09848 15.6537 9.10643 15.6681C9.11318 15.6802 9.12008 15.6921 9.12712 15.7037C9.6617 16.5814 10.5155 17.1491 12.1444 17.2542C13.1897 17.3217 15.0719 17.2394 16.5924 15.6681C17.3481 14.8871 17.6039 14.2061 17.6273 13.7502C17.6488 13.3332 17.4887 13.0336 17.1789 12.8289C17.0886 12.7692 16.8366 12.6904 16.4634 12.6496C16.3026 12.6319 16.1558 12.625 16.0495 12.6226C15.997 12.6215 15.9223 12.6219 15.8961 12.6221C15.5464 12.6326 15.2151 12.4798 14.9948 12.2107L17.7472 10.6217C17.9854 10.711 18.2262 10.824 18.4193 10.9517C19.4114 11.6072 19.9357 12.6745 19.8744 13.8659C19.815 15.0185 19.2207 16.1875 18.2093 17.2327C16.1955 19.3138 13.6527 19.6062 11.9995 19.4995C10.0147 19.3715 8.28282 18.6429 7.20553 16.8741Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '9b380804',
      "x1": "24",
      "y1": "24",
      "x2": "0",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0.029618",
      "stop-color": "#0A6CFF"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#29A9FF"
    }
  })])])]);
});